export default __webpack_public_path__ + "static/media/icon_lock.51049f16.svg";